<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('sections')"
          :description="$t('From Here You Can Control Product Sections')"
        />
        <indexTable
          :searchText="$t('Search For A section')"
          :emptyTableText="$t('There Are no Sections')"
          :buttonRole="$checkRole('products_add')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('Section Name'),
              type: 'text',
              sort: true
            },
            {
              column: 'parent_id',
              title: $t('Father Section'),
              type: 'link',
              to: 'section',
              sort: true,
              link: false
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: $checkRole('products_edit') },
                {
                  name: 'delete',
                  role: $checkRole('products_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/sections'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
